// Соединение берём общее, через initializeDB: сырой openDB(DB_NAME, DB_VERSION)
// заводил на каждый вызов отдельное соединение и никогда его не закрывал.
// Пока версия БД не менялась, это просто копило коннекты; при смене версии
// апгрейд вставал намертво, ожидая их закрытия, и приложение зависало.
import { initializeDB } from '../config/db';
import { TORQUE_MAP_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

const torqueMapService = {
    /**
     * Submit torque map to server
     */
    async submit(torqueMap) {
        try {
            const response = await axiosInstance.post('/torque-map/submit', torqueMap);
            return response.data;
        } catch (error) {
            console.error('Error submitting torque map:', error);
            throw error;
        }
    },

    /**
     * Save torque map as draft in IndexedDB
     */
    async saveDraft(torqueMap) {
        const db = await initializeDB();
        const now = new Date().toISOString();

        const torqueMapToSave = {
            ...torqueMap,
            status: 'draft',
            updatedAt: now
        };

        if (!torqueMapToSave.createdAt) {
            torqueMapToSave.createdAt = now;
        }

        await db.put(TORQUE_MAP_STORE, torqueMapToSave);
        return torqueMapToSave;
    },

    /**
     * Load torque map by UUID from IndexedDB
     */
    async loadByUuid(uuid) {
        const db = await initializeDB();
        return await db.get(TORQUE_MAP_STORE, uuid);
    },

    /**
     * Get all torque maps from IndexedDB
     */
    async getAll() {
        const db = await initializeDB();
        return await db.getAll(TORQUE_MAP_STORE);
    },

    /**
     * Delete torque map from IndexedDB
     */
    async delete(uuid) {
        const db = await initializeDB();
        await db.delete(TORQUE_MAP_STORE, uuid);
    }
};

export default torqueMapService;
